export default "__VITE_ASSET__BteN1MUX__"